import React from 'react';
import cx from './index.module.scss';
import awards from '../../assets/awards.data';
import {getCompanyByName} from '../../assets/companies.data';
import { ReactComponent as IconMore } from '../../assets/images/icon_more.svg';

const Awards = ({onClick}) => {
  return (
    <div className={cx.wrap}>
      <div className={cx.title}>
        <img className={cx.image} src={`${process.env.PUBLIC_URL}/images/title_awards.png`} alt="재직자가 행복한 기업 TOP 10 (가나다순)"/>
      </div>
      <div className={cx.list}>
        {awards.map(({name, logo, comment}) => (
          <div className={cx.item} key={`award-item-${name}`}>
            <button className={cx.inner} type="button" onClick={() => onClick(getCompanyByName(name))}>
              <div className={cx.name}>
                {logo && <img className={cx.logo} src={`${process.env.PUBLIC_URL}/images/${logo}`} alt={name} />}
                <div className={cx.text}><IconMore className={cx.iconMore} /> 자세히보기</div>
              </div>
              <div className={cx.comment}>"{comment}"</div>
            </button>
          </div>
        ))}
      </div>
    </div>
  )
};

export default Awards;
